import { render, staticRenderFns } from "./region-select.vue?vue&type=template&id=1bb0d353"
import script from "./region-select.vue?vue&type=script&lang=ts"
export * from "./region-select.vue?vue&type=script&lang=ts"
import style0 from "./region-select.vue?vue&type=style&index=0&id=1bb0d353&prod&lang=stylus"
import style1 from "./region-select.vue?vue&type=style&index=1&id=1bb0d353&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports